import '../scss/boiler-selector.scss';

const angular = require('angular');
const angularAnimate = require('angular-animate');
const svgxuse = require('svgxuse');

import '../icons/ketelkiezer_appartement.svg';
import '../icons/ketelkiezer_bad.svg';
import '../icons/ketelkiezer_douche_normaal.svg';
import '../icons/ketelkiezer_douche_spaar.svg';
import '../icons/ketelkiezer_douche_stort.svg';
import '../icons/ketelkiezer_douche.svg';
import '../icons/ketelkiezer_douchebad.svg';
import '../icons/ketelkiezer_hoekwoning.svg';
import '../icons/ketelkiezer_isolatie_gemiddeld.svg';
import '../icons/ketelkiezer_isolatie_goed.svg';
import '../icons/ketelkiezer_isolatie_minimaal.svg';
import '../icons/ketelkiezer_tussenwoning.svg';
import '../icons/ketelkiezer_verwarming.svg';
import '../icons/ketelkiezer_vrijstaand.svg';
import '../icons/ketelkiezer_warmwater.svg';

(function() {
    "use strict";

    var App = angular.module("myApp", ['ngAnimate']);

    // Custom filter object to array
    App.filter('array', function() {
        return function(items) {

            var filtered = [];

            angular.forEach(items, function(item) {
                filtered.push(item);
            });

            return filtered;
        };
    });



    // Custom filter 
    App.filter('group_by', ['$filter', '$rootScope', function($filter, $rootScope) {
        return function(items, volgorde) {

            var sorted_tmp = $filter('orderBy')(items, ['data.cw_class', 'data.nominal_load_lower_value', 'data.nominal_load_lower_value_tap_water']);

            function isInArray(value, array) {
                return array.indexOf(value) > -1;
            }

            var arr = [];
            var types = [];
            var ids = [];
            var teller = 1;

            angular.forEach(sorted_tmp, function(value, key) {
                if ( isInArray(value.related_product_type, types) === false  && teller <= 3) {
                    teller = teller + 1;
                    types.push(value.related_product_type);
                    ids.push(value.id);

                    arr.push(value);

                }
            });

            // Voeg een tweede model van eerste type toe in zelfde range als arr.lenth < 3
            angular.forEach(sorted_tmp, function(value, key) {
                if (  isInArray(value.id, ids) === false  && teller <= 3) {
                    teller = teller + 100;
                    types.push(value.related_product_type);
                    ids.push(value.id);
                    
                    arr.push(value);
                }
            });


            // sort array on prevered types (in ACF backend)
            var sortOrder = volgorde.split(','); 
            sortOrder.reverse();
            var output = arr.sort(function(a, b) {
                return sortOrder.indexOf(b.related_product_type) - sortOrder.indexOf(a.related_product_type);
            });

            $rootScope.filteredProducts = output;

            return output;

        };
    }]);




    // Custom filter 
    App.filter('ketelFilter', function() {
        return function(items, data, scope) {


            // define all vars
            var filtered = [];
            var watt_per_m3 = 40;
            var max_watt;
            var uc;
            var water_power_required = 0;
            var heating_power_required = 0;

            // sync data met filter arguments
            var typeketel = data[0];

            var woning = data[1];
            var isolatie = data[2];
            var woninginhoud = data[3];
            var gebruik = data[4];
            var douchekop = data[5];
            var gelijktijdig = data[6];



            // VERWARMEN Correctie formule
            // update correctie_isolatie
            var correctie_isolatie = 0;
            if (isolatie == 0) correctie_isolatie = 0;
            if (isolatie == 1) correctie_isolatie = 0.05;
            if (isolatie == 2) correctie_isolatie = 0.25;

            var correctie_woning = 0;
            if (woning == 0) correctie_woning = 0;
            if (woning == 1) correctie_woning = 0.02;
            if (woning == 2) correctie_woning = 0.06;
            if (woning == 3) correctie_woning = 0.10;

            // Type kerel
            if (typeketel == 0) water_power_required = 1; // alleen warmwater
            if (typeketel == 1) water_power_required = 0; // alleen verwarmen
            if (typeketel == 2) water_power_required = 1; // combi ketel

            // bereken het benodigte aantal KW voor verwarmen
            if (correctie_isolatie == 0) {
                heating_power_required = woninginhoud / 1000 * watt_per_m3;
            } else {
                uc = woninginhoud / 1000 * watt_per_m3;
                heating_power_required = uc + (uc * correctie_isolatie) + (uc * correctie_woning);
            }


            var CW = 0;


            switch (gebruik) {

                case '0': // allen douche
                if (douchekop == 0 && gelijktijdig == 0) CW = 3;
                if (douchekop == 0 && gelijktijdig == 1) CW = 4;

                if (douchekop == 1 && gelijktijdig == 0) CW = 4;
                if (douchekop == 1 && gelijktijdig == 1) CW = 5;

                if (douchekop == 2 && gelijktijdig == 0) CW = 5;
                if (douchekop == 2 && gelijktijdig == 1) CW = 6;

                

                break;



                case '1': // douche + bad


                var typebad = 1;
                    // type douchekop = 0 (spaar)
                    if (douchekop == 0 && typebad == 0 && gelijktijdig == 0) CW = 3;
                    if (douchekop == 0 && typebad == 0 && gelijktijdig == 1) CW = 4;
                    //if( douchekop == 0 && typebad == 0 && gelijktijdig == 0) CW = 5; // extra

                    if (douchekop == 0 && typebad == 1 && gelijktijdig == 0) CW = 4;
                    if (douchekop == 0 && typebad == 1 && gelijktijdig == 1) CW = 5;
                    //if( douchekop == 0 && typebad == 1 && gelijktijdig == 0) CW = 6; // extra

                    if (douchekop == 0 && typebad == 2 && gelijktijdig == 0) CW = 5;
                    if (douchekop == 0 && typebad == 2 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 0 && typebad == 2 && gelijktijdig == 0) CW = x; // extra



                    // type douchekop = 1 (normaal)
                    if (douchekop == 1 && typebad == 0 && gelijktijdig == 0) CW = 4;
                    if (douchekop == 1 && typebad == 0 && gelijktijdig == 1) CW = 5;
                    //if( douchekop == 1 && typebad == 0 && gelijktijdig == 0) CW = 6; // extra

                    if (douchekop == 1 && typebad == 1 && gelijktijdig == 0) CW = 4;
                    if (douchekop == 1 && typebad == 1 && gelijktijdig == 1) CW = 5;
                    //if( douchekop == 1 && typebad == 1 && gelijktijdig == 0) CW = 6; // extra

                    if (douchekop == 1 && typebad == 2 && gelijktijdig == 0) CW = 5;
                    if (douchekop == 1 && typebad == 2 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 1 && typebad == 2 && gelijktijdig == 0) CW = x; // extra




                    // type douchekop = 2 (stort)
                    if (douchekop == 2 && typebad == 0 && gelijktijdig == 0) CW = 6;
                    if (douchekop == 2 && typebad == 0 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 1 && typebad == 0 && gelijktijdig == 0) CW = X; // extra

                    if (douchekop == 2 && typebad == 1 && gelijktijdig == 0) CW = 6;
                    if (douchekop == 2 && typebad == 1 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 1 && typebad == 1 && gelijktijdig == 0) CW = X; // extra

                    if (douchekop == 2 && typebad == 2 && gelijktijdig == 0) CW = 6;
                    if (douchekop == 2 && typebad == 2 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 1 && typebad == 2 && gelijktijdig == 0) CW = X; // extra

                    break;




                case '2': // douchebad


                var typebad = 1;
                    // type douchekop = 0 (spaar)
                    if (douchekop == 0 && typebad == 0 && gelijktijdig == 0) CW = 3;
                    if (douchekop == 0 && typebad == 0 && gelijktijdig == 1) CW = 4;
                    //if( douchekop == 0 && typebad == 0 && gelijktijdig == 0) CW = 5; // extra

                    if (douchekop == 0 && typebad == 1 && gelijktijdig == 0) CW = 4;
                    if (douchekop == 0 && typebad == 1 && gelijktijdig == 1) CW = 5;
                    //if( douchekop == 0 && typebad == 1 && gelijktijdig == 0) CW = 6; // extra

                    if (douchekop == 0 && typebad == 2 && gelijktijdig == 0) CW = 5;
                    if (douchekop == 0 && typebad == 2 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 0 && typebad == 2 && gelijktijdig == 0) CW = x; // extra



                    // type douchekop = 1 (normaal)
                    if (douchekop == 1 && typebad == 0 && gelijktijdig == 0) CW = 4;
                    if (douchekop == 1 && typebad == 0 && gelijktijdig == 1) CW = 5;
                    //if( douchekop == 1 && typebad == 0 && gelijktijdig == 0) CW = 6; // extra

                    if (douchekop == 1 && typebad == 1 && gelijktijdig == 0) CW = 4;
                    if (douchekop == 1 && typebad == 1 && gelijktijdig == 1) CW = 5;
                    //if( douchekop == 1 && typebad == 1 && gelijktijdig == 0) CW = 6; // extra

                    if (douchekop == 1 && typebad == 2 && gelijktijdig == 0) CW = 5;
                    if (douchekop == 1 && typebad == 2 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 1 && typebad == 2 && gelijktijdig == 0) CW = x; // extra




                    // type douchekop = 2 (stort)
                    if (douchekop == 2 && typebad == 0 && gelijktijdig == 0) CW = 6;
                    if (douchekop == 2 && typebad == 0 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 1 && typebad == 0 && gelijktijdig == 0) CW = X; // extra

                    if (douchekop == 2 && typebad == 1 && gelijktijdig == 0) CW = 6;
                    if (douchekop == 2 && typebad == 1 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 1 && typebad == 1 && gelijktijdig == 0) CW = X; // extra

                    if (douchekop == 2 && typebad == 2 && gelijktijdig == 0) CW = 6;
                    if (douchekop == 2 && typebad == 2 && gelijktijdig == 1) CW = 6;
                    //if( douchekop == 1 && typebad == 2 && gelijktijdig == 0) CW = X; // extra


                    

                    break;



                }


            // EINDE WARMWATER

            //console.clear();
            
            if( CW == 0){
                console.info( "------ CW ", 'Geen water behoefte');
                scope.CW_required =  'Geen water behoefte';
            }else{
                console.info( "------ CW ", 'CW' + CW);
                scope.CW_required = CW
            }

            if( ! heating_power_required){
                console.info( "------ HP ", 'Geen warmte behoefte');
                scope.heating_power_required =  'Geen warmte behoefte';
            }else{
                console.info( "------ HP ", heating_power_required +' kW');
                scope.heating_power_required =  heating_power_required +' kW';
            };


            // Filter array on heating_power_required & water_power_required
            // Return: Array()
            if(items){
                for (var i = 0; i < items.length; i++) {

                    var item = items[i];
                    var check = true;

                    ///////////////////////////////////////
                    // filter min heating power ///////////
                    ///////////////////////////////////////

                    // fix when no data has been loaded by $scope.alleKetels()
                    if (item == 0) {
                        item = {
                            data: {}
                        };
                    }


                    //////////////////////////////////////
                    // filter min water power ////////////
                    //////////////////////////////////////


                    var water_power = isNaN(parseInt(item.data.cw_class)) ? 0 : parseInt(item.data.cw_class);
                    var heating_power = isNaN(parseInt(item.data.rated_power_80_60c)) ? 0 : parseInt(item.data.rated_power_80_60c);

                    // alleen warm water (sluit alle met verwarming)
                    if (typeketel == 0 && parseInt(item.data.rated_power_80_60c) >= 1){
                    check = false;   
                    }

                    // alleen verwarming (sluit alle met warmwater uit)
                    if (typeketel == 1 && water_power >= 1){
                    check = false;   
                    }

                    // check water kW
                    if (typeketel != 1 && water_power < CW) {
                        check = false;
                    }

                    // check verwarming kW
                    if (typeketel != 0 && heating_power < heating_power_required) {
                        check = false;
                    }



                    if (check === true) {
                        filtered.push(item);
                    }


                }
            }




            //console.clear();
            angular.forEach(filtered, function(value, key) {
                // console.info(key, value);
            });


            //var tmp = $filter('groupBy')(filtered, 'related_product_type');
            //console.info( tmp );

            return filtered;

        };
    });



    App.directive('myclick', ['$timeout', function($timeout) {

        return function(scope, element, attrs) {

            element.bind('touchstart click', function(event) {


                var timer;

                event.preventDefault();
                event.stopPropagation();


                if (timer) {
                    $timeout.cancel(timer);
                }
                timer = $timeout(function() {
                    scope.$apply(attrs['myclick']);
                }, 100);

            });
        };
    }]);

    App.controller("ketelkiezer_controller", ['$scope', '$timeout', '$http', '$filter', function($scope, $timeout, $http, $filter) {


        // define all vars
        $scope.stap = 0;
        $scope.verwarmen = true;
        $scope.done = false;
        $scope.situatie_gegevens = {};
        $scope.ketelkiezer_ingevuld = true;
        $scope.showLimit = 300;

        $scope.hideBack = false;

        // Filter keuze opties
        $scope.filter = function(e) {
            // Verwarming nodig?


            $scope.form[1].filter = true;
            $scope.form[2].filter = true;
            $scope.form[3].filter = true;
            $scope.form[4].filter = true;
            $scope.form[5].filter = true;
            $scope.form[6].filter = true;

            // alleen warm water
            if ($scope.form[0].velden[0].status && $scope.form[0].velden[0].status == 'active') {
                $scope.form[1].filter = false;
                $scope.form[2].filter = false;
                $scope.form[3].filter = false;
            }


            // alleen verwarmen
            if ($scope.form[0].velden[1].status && $scope.form[0].velden[1].status == 'active') {
                $scope.form[4].filter = false;
                $scope.form[5].filter = false;
                $scope.form[6].filter = false;
            }

            // combi
            if ($scope.form[0].velden[2].status && $scope.form[0].velden[2].status == 'active') {
                // $scope.verwarmen = true;
            }


            // goto next step
            $scope.next();

        };



        var timer;

        // Click event
        $scope.toggleActive = function(rowIndex, valueIndex) {

            // remove all active classes from current rowIndex element
            angular.forEach($scope.form[rowIndex].velden, function(value, key) {
                delete value.status;
            });

            // Add active class to clicked element
            $scope.form[rowIndex].velden[valueIndex].status = 'active';

            $scope.situatie_gegevens[rowIndex] = $scope.form[rowIndex].velden[valueIndex].value;

            // Filter product array
            $scope.filter();


        };



        // Goto next question
        $scope.next = function() {

            $scope.hideBack = false;

            $scope.stap++;

            for (var veld in $scope.form) {
                if ($scope.form[$scope.stap] && $scope.form[$scope.stap].filter == false) {
                    $scope.stap++;
                }
            }


            var count = Object.keys($scope.form).length;
            if ($scope.stap == count) {

                $scope.showBestChoice = true;
                $scope.done = true;
                //console.log($scope.filteredProducts);
                if(typeof Hooks === 'function'){
                    const hooks = new Hooks();
                    setTimeout(function(){
                        //console.log($scope.filteredProducts);
                        hooks.triggerAction('boilerSelectorAdviceGenerated', [$scope.filteredProducts]);
                    }, 50);
                }

                return false;
            }


        };





        // Ga naar een specifieke vraag
        $scope.gotoStap = function(index) {
            //console.log($scope.stap, index)

            if (index >= $scope.stap) return false;

            // wis selectie in navolgende stappen
            angular.forEach($scope.form, function(value, key) {
                if (key > index) {
                    $scope.situatie_gegevens[key] = '';
                    angular.forEach($scope.form[key].velden, function(formvalue, veldkey) {
                        $scope.form[key].velden[veldkey].status = '';
                    });
                }
            });

            $scope.hideBack = true;
            $scope.done = false;
            $scope.stap = index;

        };




        // Recive all boilers
        $scope.alleKetels = function() {

            $scope.allBoilers = {};

            $http({
                method: 'POST',
                url: '/wp-admin/admin-ajax.php',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {
                    action: 'Boilers', // (zie functions.php in root)
                    nonce: ajax_var.nonce,
                    function: 'getAllBoilers',
                    uitsluitingen: $scope.uitsluitingen,
                    current_section: $scope.current_section
                }
            }).then(function(data) {
                $scope.allBoilers = data.data;

                //console.log(data.data);

                $timeout(function() {
                    $scope.appReady = {
                        opacity: 1,
                        transition: '0.5s'
                    };
                }, 1000);

                //console.info(data);

            });

        };

        // Het dynamische formulier
        $scope.form = boilerCompareQuestions;


        // haal alle ketels op uit DB met een WP functie (zie functions.php in root)
        $timeout(function() {
            $scope.alleKetels();
        });



    }]);
})();